import Box from "@mui/material/Box";
import FormSection from "components/forms/FormSection";
import { FamilyRestroomOutlined } from "@mui/icons-material";
import EmployeeCollectionTable from "pages/EmployeeWorkspace/components/EmployeeCollectionTable";
import resource from "pages/EmployeeWorkspace/Resources/familyMemberResource";
import { Button } from "@mui/material";
import { useState } from "react";
import FamilyMemberDialog from "pages/EmployeeWorkspace/components/Tabs/components/FamilyBackgroundTab/components/FamilyMemberDialog";
import DeleteConfirmationDialog from "features/maintenance/components/DeleteConfirmationDialog";
import EmptyPlaceHolder from "pages/EmployeeWorkspace/components/EmptyPlaceHolder";

export default function FamilyBackgroundTab({ form, updateField }) {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [editingIndex, setEditingIndex] = useState(null);
    const [dataToDelete, setDataToDelete] = useState(null);
    const [idsToDelete, setIdsToDelete] = useState(null);

    const editingData =
        editingIndex !== null
            ? form[resource.collectionField]?.[editingIndex]
            : null;

    // onDeleteSelected
    const onBatchDelete = (selectedRows) => {
        setIdsToDelete(selectedRows);
    };
    const handleBatchDelete = (idsTobeDeleted = []) => {
        if (idsTobeDeleted.length) {
            const rows = form[resource.collectionField];
            const idsToDelete = new Set(
                idsTobeDeleted
                    .filter((r) => r.id !== undefined)
                    .map((r) => r.id)
            );
            const rowIdsToRemove = new Set(
                idsTobeDeleted
                    .filter((r) => r.rowId !== undefined)
                    .map((r) => r.rowId)
            );

            // Process rows
            const finalData = rows
                .filter((row) => !rowIdsToRemove.has(row.rowId)) // remove rows with matching rowId
                .map((row) => {
                    if (row.id !== undefined && idsToDelete.has(row.id)) {
                        return { ...row, isDeleted: true }; // mark as deleted
                    }
                    return row;
                });
            console.log({ finalData });

            updateField(resource.collectionField, [...finalData]);
            setIdsToDelete(null);
        }
    };

    const handleSave = (newData) => {
        const data = { ...newData, rowId: newData?.id || crypto.randomUUID() };
        const currentData = form[resource.collectionField] ?? [];

        if (editingIndex !== null) {
            const updatedData = [...currentData];

            updatedData[editingIndex] = data;

            updateField(resource.collectionField, updatedData);
        } else {
            updateField(resource.collectionField, [...currentData, data]);
        }

        setEditingIndex(null);
        setDialogOpen(false);
    };

    const handleAdd = () => {
        setEditingIndex(null);
        setDialogOpen(true);
    };
    const handleEdit = (data, index) => {
        setEditingIndex(index);
        setDialogOpen(true);
    };

    const handleDelete = () => {
        const currentData = form[resource.collectionField] ?? [];

        if (!dataToDelete) {
            return;
        }

        let updatedData;

        if (dataToDelete.id > 0) {
            updatedData = currentData.map((values) =>
                values === dataToDelete
                    ? {
                          ...values,
                          isDeleted: true
                      }
                    : values
            );
        } else {
            updatedData = currentData.filter(
                (values) => values !== dataToDelete
            );
        }

        updateField(resource.collectionField, updatedData);

        setDataToDelete(null);
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1.5
            }}
        >
            <FormSection title={resource.title} icon={FamilyRestroomOutlined}>
                {!form[resource.collectionField]?.length ? (
                    <EmptyPlaceHolder
                        title={resource.title}
                        onAdd={handleAdd}
                        icon={FamilyRestroomOutlined}
                    />
                ) : (
                    <EmployeeCollectionTable
                        resource={resource}
                        rows={(form[resource.collectionField] ?? []).filter(
                            (values) => !values.isDeleted
                        )}
                        onEdit={handleEdit}
                        onDelete={(values) => {
                            setDataToDelete(values);
                        }}
                        onAdd={handleAdd}
                        onDeleteSelected={onBatchDelete}
                    />
                )}
                <FamilyMemberDialog
                    open={dialogOpen}
                    item={editingData}
                    onCancel={() => {
                        setDialogOpen(false);
                        setEditingIndex(null);
                    }}
                    onSave={handleSave}
                />
                <DeleteConfirmationDialog
                    open={dataToDelete !== null}
                    title={`Delete ${resource.title}`}
                    message={`Are you sure you want to remove this ${resource.title}?`}
                    onCancel={() => setDataToDelete(null)}
                    onConfirm={handleDelete}
                />

                <DeleteConfirmationDialog
                    open={idsToDelete?.length > 0}
                    title={`Delete`}
                    message={`Are you sure you want to remove ${idsToDelete?.length} items?`}
                    onCancel={() => setIdsToDelete(null)}
                    onConfirm={() => handleBatchDelete(idsToDelete)}
                />
            </FormSection>
        </Box>
    );
}
